import script from "./customField.vue?vue&type=script&setup=true&lang=js"
export * from "./customField.vue?vue&type=script&setup=true&lang=js"

import "./customField.vue?vue&type=style&index=0&id=000b33d2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-000b33d2"]])

export default __exports__